
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import AuthHeader from "@/components/layout/auth-header.vue";
import SideLayout from "@/components/layout/SideLayout.vue";
import { Component, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import AiLogin from "@/content/aiLogin.vue";
import vuexStore from "@/store/vuex-store";

@Component({
  components: {
    SideLayout,
    AuthHeader,
    AiLogin
  }
})
export default class App extends Vue {
  // showLogin = true;
  show = true; //匿名页面不展示
  showCompany = false; //公司卡片
  showGuide = false; //展示新手引导
  userInfoReady = false; //header里用户信息加载完毕

  get includePages() {
    return vuexStore.keepAlivePages;
  }

  created() {
    document.title = ["380", "91418"].includes(Auth.companyId)
      ? "牛人星球"
      : "海纳AI面试";
    // if (Auth.token) {
    //   this.showLogin = false;
    // } else {
    //   // this.$router.push(`/`);
    //   this.showLogin = true;
    // }
    this.showGuide = localStorage.getItem("showNewTip") !== "1";
  }
  mounted() {
    //阅卷页面头部仅供展示
    this.show =
      this.$route.name === "paper-mark" ||
      this.$route.name === "candidate-info" ||
      this.$route.name === "paper-mark-mobile" ||
      this.$route.name === "candidates-info"
        ? false
        : true;
  }
  closeCompany() {
    vuexStore.updateShowCompany(false);
  }
}
